var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.showMsg
      ? _c("div", { attrs: { id: "cookies-warning" } }, [
          _c("div", [
            _c(
              "p",
              [
                _vm._t("text", function () {
                  return [
                    _vm._v(
                      "\n                    BY USING THIS WEBSITE, YOU AGREE TO OUR\n                "
                    ),
                  ]
                }),
                _vm._v(" "),
                _vm._t("modal-link", function () {
                  return [
                    _c("button", { attrs: { type: "button" } }, [
                      _vm._v("COOKIE POLICY"),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cookies-close",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.setMsgCookie(false)
                },
              },
            },
            [
              _vm._t("close", function () {
                return [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 25.38 24.04",
                        width: "15",
                        height: "15",
                      },
                    },
                    [
                      _c("polygon", {
                        staticStyle: { fill: "#fff" },
                        attrs: {
                          points:
                            "23.96 2.47 22.55 1.06 12.69 10.91 2.84 1.06 1.42 2.47 11.28 12.32 1.42 22.18 2.84 23.59 12.69 13.74 22.55 23.59 23.96 22.18 14.11 12.32 23.96 2.47",
                        },
                      }),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }